import {
  Alert, DialogContentText, FormControl, FormControlLabel, Radio, RadioGroup, Typography,
} from '@mui/material';
import React, { useState } from 'react';
import CustomConfirmDialog from '../shared/material_components/custom-confirm-dialog';

export const TASK_ONLY_VALUE = 'taskOnly';
export const TASK_AND_RECURRENCE_VALUE = 'taskAndRecurrence';

export type DeleteOption = typeof TASK_ONLY_VALUE | typeof TASK_AND_RECURRENCE_VALUE;

interface Props {
  open: boolean;
  hasError: boolean;
  hasRecurrence: boolean;
  recordType?: 'task' | 'issue' | 'record';
  onPositive: (deleteOption: DeleteOption) => void;
  onNegative: () => void;
}

function RecordDeleteDialog({
  open, recordType = 'record', onPositive, onNegative, hasError, hasRecurrence,
}: Props) {
  const [radioValue, setRadioValue] = useState<DeleteOption>(TASK_ONLY_VALUE);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = (event.target as HTMLInputElement).value as DeleteOption;
    setRadioValue(selectedOption);
  };
  const handlePositive = () => onPositive(radioValue);
  const handleNegative = () => {
    setTimeout(() => setRadioValue(TASK_ONLY_VALUE), 400); // reset radio after animation ends
    onNegative();
  };

  return (
    <CustomConfirmDialog
      open={open}
      onClose={onNegative}
      title={`Delete ${recordType}`}
      error={hasError}
      positive={`Delete ${recordType}`}
      onNegative={handleNegative}
      onPositive={handlePositive}
    >
      <DialogContentText component="span" data-testid="dialog-content">
        {!hasError ? (
          <>
            <Typography variant="body1">
              Are you sure you want to
              <strong> permanently delete </strong>
              this
              {' '}
              {recordType}
              ? This action cannot be undone.
            </Typography>
            { hasRecurrence && (
              <>
                <FormControl>
                  <RadioGroup name="task-series-scope" value={radioValue} onChange={handleChange}>
                    <FormControlLabel
                      value={TASK_ONLY_VALUE}
                      control={<Radio />}
                      label="Delete this task only"
                    />
                    <FormControlLabel
                      value={TASK_AND_RECURRENCE_VALUE}
                      control={<Radio />}
                      label="Delete this task and turn off the recurrence"
                    />
                  </RadioGroup>
                </FormControl>
              </>
            )}
          </>
        ) : (
          <Alert severity="error">
            There was an error deleting this record.
          </Alert>
        )}
      </DialogContentText>
    </CustomConfirmDialog>
  );
}

export default RecordDeleteDialog;
